import { PaymentOption } from '../../features/refiApp/coverages/paymentOptions'
import {
  FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS,
  FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS_ERROR,
  FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS_SUCCESS,
  RESET_PRODUCT_PACKAGE_PAYMENT_OPTIONS,
} from '../../features/refiApp/productPackageActions'

const initialDataValue: PaymentOption[] = []

const initialState = {
  loading: false,
  data: initialDataValue,
}

const paymentOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS:
      return {
        loading: true,
        data: [],
      }
    case FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
      }
    case FETCH_PRODUCT_PACKAGE_PAYMENT_OPTIONS_ERROR:
      return {
        loading: false,
        data: [],
      }
    case RESET_PRODUCT_PACKAGE_PAYMENT_OPTIONS:
      return initialState
    default:
      return state
  }
}
export default paymentOptionsReducer
